import React from 'react'
import { EventsPageList,TechnicalEvents } from './Data'
import { useNavigate } from 'react-router-dom';


const Events = () => {

    const history=useNavigate();
    const eventHandler2=(page)=>{
        window.scrollTo(0,0)
        history(page)
      }
    const eventHandler=(register)=>{
       window.open(register);
      }

    return (
        <>
           <div className="events">
               <div className="events__wrapper">
                   <h1>Events</h1>
               </div>
               <div className="events__cover"></div>
               <div className="events__content">
                   <h2>Technical Events</h2>
                   <div className="list_events">

                       {
                           TechnicalEvents.map((item)=>{
                               return(
                                <div key={item.id} className="event1">
                                <div className="img__content">
                                <img src={item.img} alt="" />
                                <div className="content">
                                    <h3>{item.name}</h3>
                                    {/* <p>{item.description}</p> */}
                                </div>
                                </div>
                                 <div className="inner">
                                     <button onClick={()=>eventHandler(item.register)}>register</button>
                                     <button onClick={()=>eventHandler2(item.explore)}>explore</button>
                                 </div>
                                 </div> 
                               )
                           })
                       }
                     
                     
                       </div>        

                       <h2>Non-Technical Events</h2>
                       <div className="list_events">

{
    EventsPageList.map((item)=>{
        return(
         <div key={item.id} className="event1">
         <div className="img__content">
         <img src={item.img} alt="" />
         <div className="content">
             <h3>{item.name}</h3>
             {/* <p>{item.first}</p> */}
         </div>
         </div>
          <div className="inner">
              <button onClick={()=>eventHandler(item.register)}>register</button>
              <button onClick={()=>eventHandler2(item.explore)}>explore</button>
          </div>
          </div> 
        )
    })
}


</div> 
                </div>
            </div> 
        </>
    )
}

export default Events
